module.exports = __webpack_public_path__ + "static/media/chain.ebadf6a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/chain.mp3
// module id = t1hB
// module chunks = 1